



































































import { Vue, Component, Prop, Mixins, Watch } from "vue-property-decorator";
import RequestData from "@/store/types/RequestData";
import { RegisterHttp } from "@/utils/Decorators";
import { currentScoutingStore, currentUserStore } from "@/store/typed";
import { SEARCH_PLACE_TAG } from "@/mixins/http/GooglePlaceMixin";
import GooglePlaceMixin from "@/mixins/http/GooglePlaceMixin";
import EntryList from "@/components/EntryList.vue";
import Company, { CompanyFilter } from "@/models/Company";
import CompanyMixin from "@/mixins/http/CompanyMixin";
import { CompanyPlaceFilter } from "@/models/CompanyPlace";
import { ScoutingPlace } from "@/models";
import { UserRoles } from "@/models/User";
import { SCOUTING_PLACE_SOURCE } from "@/models/ScoutingPlace";

@Component({
  components: { EntryList },
})
export default class PoiSearch extends Mixins(GooglePlaceMixin, CompanyMixin) {
  @RegisterHttp(SEARCH_PLACE_TAG) readonly searchRequest!: RequestData;

  private mode: "google" | "companies" = "google";
  private companies: Company[] = [];
  private term = "";
  private termCompany = "";
  private termCompanyMinLength = 1;

  private dropdownVisible = false;

  mounted() {}

  get isGoogle() {
    return this.mode === "google";
  }

  get isCompanies() {
    return this.mode === "companies";
  }
  get displayClientSection() {
    return currentUserStore.user?.isOneOf([
      UserRoles.ANALYST,
      UserRoles.ADMINISTRATOR,
      UserRoles.SUPERADMIN,
      UserRoles.SYSTEM_ADMIN,
    ]);
  }

  search() {
    currentScoutingStore.clearMarkers();
    this.$router.push({
      name: "scouting-poi-search",
      params: {
        term: this.term,
        source: this.mode,
      },
    });
  }

  protected onKeyUp() {
    if (this.termCompany.length >= this.termCompanyMinLength) {
      this.searchCompanies();
    } else if (this.termCompany.length === 0) {
      this.companies = [];
      this.closeDropdown();
    }
  }

  async searchCompanies() {
    const filter = new CompanyFilter();
    filter.name = this.termCompany;
    this.companies = await this.getCompanies(filter);
    this.showDropdown();
  }

  protected async onSelected(value: Company) {
    this.termCompany = value.name;
    this.closeDropdown();
    const clientScoutingPlaces: ScoutingPlace[] =
      await this.getScoutingPlacesFromCompany(value);
    await currentScoutingStore.addClientScoutingPlaces(clientScoutingPlaces);
  }

  async getScoutingPlacesFromCompany(company: Company) {
    const filter: CompanyPlaceFilter = new CompanyPlaceFilter();
    filter.companyId = company.id;
    const clientPlaces = await this.getCompanyPlaces(filter);
    const scoutingPlaces: ScoutingPlace[] = [];

    for (const clientPlace of clientPlaces) {
      if (clientPlace.status !== "ready") continue;

      const scoutingPlace: ScoutingPlace = new ScoutingPlace();
      scoutingPlace.clientPlaceId = clientPlace.id;
      scoutingPlace.name = clientPlace.name;
      scoutingPlace.fullAddress = clientPlace.fullAddress;
      scoutingPlace.position = clientPlace.position;
      scoutingPlace.source = SCOUTING_PLACE_SOURCE.CLIENT;
      scoutingPlace.sourceId = clientPlace.sourceId;
      scoutingPlace.highlighted = true;
      scoutingPlaces.push(scoutingPlace);
    }

    return scoutingPlaces;
  }

  protected showDropdown() {
    this.dropdownVisible = true;
  }

  protected closeDropdown() {
    this.dropdownVisible = false;
  }
}
